import { connect } from 'react-redux';
import { compose } from 'redux';
import { Card, Row, Col, Dropdown, Tabs, Tab } from 'react-bootstrap';
import PropertyCheckbox from './components/PropertyCheckbox';
import PropertyPicker from './components/PropertyPicker';
import BaseFeature from './BaseFeature';
import PropertyDropdown from './components/PropertyDropdown';
import { getHoursTD, getHours, getHoursTD60Hz } from '../../../../../../utils/constantValues';
import { DALI_DEXAL_SETTINGS, TOUCH_DIM_AND_SENSOR, CORRIDOR } from '../../../../../../utils/constantFeatures';
import DraggableAreaChart from './charts/DraggableAreaChart';
import { getErrorIssues } from '../../../../../../utils/validationSummary';
import { linearPercentage, logarithmicPercentage } from '../../../../../../utils/percentageUtility';
import Checkbox from 'components/shared/StandaloneCheckbox';
import { Trans, withTranslation } from 'react-i18next';

class TouchDim extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabledTdpo: this.isOn(this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnLevel]),
            isEnabledTdpo2: this.isOn(this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnLevel2]),
            isEnabledTdpoC: this.isOn(this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnColour]),
            isEnabledTdso: this.isOn(this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
            isEnabledTdso2: this.isOn(this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnLevel2]),
            isEnabledTdsoC: this.isOn(this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnColour]),
            isEnabledPD: this.isOn(this.props.properties[TOUCH_DIM_AND_SENSOR.enablePresenceDetection]),
            frequencySelected: this.props.properties[TOUCH_DIM_AND_SENSOR.mainsFrequency].value ? parseInt(this.props.properties[TOUCH_DIM_AND_SENSOR.mainsFrequency].value) : 50,
            selectedGraph: "td",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeisEnabled = this.handleChangeisEnabled.bind(this);
        this.handleChartChange = this.handleChartChange.bind(this);
        this.handleChangeFrequency = this.handleChangeFrequency.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        let isEnabledPD = this.state.isEnabledPD;

        if (this.getCorrectPropertyName(propertyName) === TOUCH_DIM_AND_SENSOR.enablePresenceDetection) {
            this.setState({ isEnabledPD: !isEnabledPD });
        }

        if (this.getCorrectPropertyName(propertyName).startsWith(DALI_DEXAL_SETTINGS.shortName)) {
            let property = this.props.extraProperties[this.getCorrectPropertyName(propertyName)];
            property.value = value;
            this.props.handleChangeExtraProperties(property);
        }
        else {
            this.props.handleChange(propertyName, v);
        }

    }

    handleChartChange() {
        this.setState({ properties: this.props.properties });
    }

    isOn(property) {
        return property !== undefined
            && property !== null
            && property.value !== undefined
            && property.value !== null
            && property.value !== ''
            && (typeof property.value === 'string' ? property.value.toUpperCase() !== 'OFF' : property.value !== property.valueMeta.off);
    }

    getPercentage(value, min, max) {
        const dimmingCurve = this.props.extraProperties[DALI_DEXAL_SETTINGS.dimmingCurve];

        if (dimmingCurve && dimmingCurve.value === '1') {
            return linearPercentage(value, min, max);
        }
        return logarithmicPercentage(value, min, max);
    }

    handleChangeisEnabled(e, property) {
        const value = e.target.checked;
        const propertyName = property.info.name;

        switch (this.getCorrectPropertyName(propertyName)) {
            case TOUCH_DIM_AND_SENSOR.mainPowerOnLevel:
                this.setState({
                    isEnabledTdpo: !value
                });
                if (value) {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.mainPowerOnLevel, "Off");
                } else {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.mainPowerOnLevel, this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnLevel].valueMeta.initial);
                }
                break;
            case TOUCH_DIM_AND_SENSOR.mainPowerOnLevel2:
                this.setState({
                    isEnabledTdpo2: !value
                });
                if (value) {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.mainPowerOnLevel2, "Off");
                } else {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.mainPowerOnLevel2, this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnLevel2].valueMeta.initial);
                }
                break;
            case TOUCH_DIM_AND_SENSOR.mainPowerOnColour:
                this.setState({
                    isEnabledTdpoC: !value
                });
                if (value) {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.mainPowerOnColour, "Off");
                } else {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.mainPowerOnColour, this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnColour].valueMeta.initial);
                }
                break;
            case TOUCH_DIM_AND_SENSOR.switchOnLevel:
                this.setState({
                    isEnabledTdso: !value
                });
                if (value) {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.switchOnLevel, "Off");
                } else {
                    //initial value can be null
                    this.handleChange(TOUCH_DIM_AND_SENSOR.switchOnLevel,
                        this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnLevel].valueMeta.initial ?
                            this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnLevel].valueMeta.initial
                            :
                            this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnLevel].valueMeta.max);
                }
                break;
            case TOUCH_DIM_AND_SENSOR.switchOnLevel2:
                this.setState({
                    isEnabledTdso2: !value
                });
                if (value) {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.switchOnLevel2, "Off");
                } else {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.switchOnLevel2, this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnLevel2].valueMeta.initial);
                }
                break;
            case TOUCH_DIM_AND_SENSOR.switchOnColour:
                this.setState({
                    isEnabledTdsoC: !value
                });
                if (value) {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.switchOnColour, "Off");
                } else {
                    this.handleChange(TOUCH_DIM_AND_SENSOR.switchOnColour, this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnColour].valueMeta.initial);
                }
                break;
            default:
                break;
        }

    }

    renderEnable_P_s(className, property, stateEnabled, labelEnable, labelPicker, measureUnit) {
        return (
            <div className="card-body-feature">
                {
                    property.valueMeta.off !== undefined && property.valueMeta.off !== null && property.valueMeta.off !== ''
                        ? <Row style={{ margin: "0.5rem auto 0", alignItems: "center" }}>
                            <Col s="2" style={{ padding: '0' }}>
                                <Checkbox
                                    checked={!stateEnabled}
                                    onChange={(e) => this.handleChangeisEnabled(e, property)}
                                />
                            </Col>
                            <Col sm="10" style={{ paddingRight: '0', paddingLeft: '0', fontSize: '0.85rem' }}>
                                {labelEnable}
                            </Col>
                        </Row>
                        : null
                }
                <div className={className} style={{ width: "100%" }}>
                    <PropertyPicker
                        disabled={!stateEnabled}
                        property={property}
                        title={labelPicker}
                        type={<Trans i18nKey="Mirek" />}
                        measureUnit={measureUnit}
                        min={property.valueMeta.min}
                        max={property.valueMeta.max}
                        step={1}
                        handleChange={this.handleChange} />
                </div>
            </div>);
    }

    handleChangeFrequency(e) {
        const v = +e.target.name;
        this.setState({ frequencySelected: v });
        this.handleChange(TOUCH_DIM_AND_SENSOR.mainsFrequency, v);
    }

    render() {

        const tdMo = this.props.properties[TOUCH_DIM_AND_SENSOR.mode];

        const tdEs1 = (tdMo.value === '1' && this.props.properties[TOUCH_DIM_AND_SENSOR.enableShortPush])
            ? this.props.properties[TOUCH_DIM_AND_SENSOR.enableShortPush]
            : this.props.properties[TOUCH_DIM_AND_SENSOR.enableShortPush1];
        const tdEl1 = (tdMo.value === '1' && this.props.properties[TOUCH_DIM_AND_SENSOR.enableLongPush])
            ? this.props.properties[TOUCH_DIM_AND_SENSOR.enableLongPush]
            : this.props.properties[TOUCH_DIM_AND_SENSOR.enableLongPush1];
        const tdEd1 = (tdMo.value === '1' && this.props.properties[TOUCH_DIM_AND_SENSOR.enableDoublePush])
            ? this.props.properties[TOUCH_DIM_AND_SENSOR.enableDoublePush]
            : this.props.properties[TOUCH_DIM_AND_SENSOR.enableDoublePush1];
        const tdEs2 = this.props.properties[TOUCH_DIM_AND_SENSOR.enableShortPush2];
        const tdEl2 = this.props.properties[TOUCH_DIM_AND_SENSOR.enableLongPush2];
        const tdEd2 = this.props.properties[TOUCH_DIM_AND_SENSOR.enableDoublePush2];
        const tdPo = this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnLevel];
        const tdPo2 = this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnLevel2];
        const tdPoC = this.props.properties[TOUCH_DIM_AND_SENSOR.mainPowerOnColour];
        const tdFu = this.props.properties[TOUCH_DIM_AND_SENSOR.fadeUpTime];
        const tdSo = this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnLevel];
        const tdSo2 = this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnLevel2];
        const tdSoC = this.props.properties[TOUCH_DIM_AND_SENSOR.switchOnColour];
        const tdOn = this.props.properties[TOUCH_DIM_AND_SENSOR.presenceHoldTime];
        const tdFt3 = this.props.properties[TOUCH_DIM_AND_SENSOR.fadeDownTime03];
        const tdSt = this.props.properties[TOUCH_DIM_AND_SENSOR.standbyHoldTime];
        const tdEls = this.props.properties[TOUCH_DIM_AND_SENSOR.enableLightSensor];
        const tdEpd = this.props.properties[TOUCH_DIM_AND_SENSOR.enablePresenceDetection];
        const tdEhm = this.props.properties[TOUCH_DIM_AND_SENSOR.enableHolidayMode];
        const tdEap = this.props.properties[TOUCH_DIM_AND_SENSOR.autoDisablePD];

        const daMin = this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum];

        const tdFd = this.props.properties[CORRIDOR.fadeDownTime]; //corridor

        let classNamePD = '';
        if (!this.state.isEnabledPD) {
            classNamePD += ' card-none';
        }

        const lightLevelControl1Component = tdEs1 && tdEl1 && tdEd1
            ? (<Card className={this.getClassName([tdEs1, tdEl1, tdEd1])}>
                <div className="card-header-feature">
                    {<Trans i18nKey="Light_Level_Control_Button_1" />}
                </div>
                <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                    <PropertyCheckbox
                        property={tdEs1}
                        title={<Trans i18nKey="Switch_ON_OFF_Short_Push" />}
                        handleChange={this.handleChange} />
                    <PropertyCheckbox
                        property={tdEl1}
                        title={<Trans i18nKey="Dim_UP_DOWN_Long_Push" />}
                        handleChange={this.handleChange} />
                    <PropertyCheckbox
                        property={tdEd1}
                        title={<Trans i18nKey="Set_Reset_level_Double_Push" />}
                        handleChange={this.handleChange} />
                </Card.Body>
            </Card>)
            : null;

        const lightLevelControl2Component = (tdMo.value === '2' || tdMo.value === '3') && tdEs2 && tdEl2 && tdEd2
            ? (<Card className={this.getClassName([tdEs2, tdEl2, tdEd2])}>
                <div className="card-header-feature">
                    {tdMo.value === '2' ? <Trans i18nKey="Light_Level_Control_Button_2" /> : <Trans i18nKey="CCT_Control_Button_2" />}
                </div>
                <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                    <PropertyCheckbox
                        property={tdEs2}
                        title={tdMo.value === '2' ? <Trans i18nKey="Switch_ON_OFF_Short_Push" /> : <Trans i18nKey="Set_Colour_to_middle_Short_Push" />}
                        handleChange={this.handleChange} />
                    <PropertyCheckbox
                        property={tdEl2}
                        title={tdMo.value === '2' ? <Trans i18nKey="Dim_UP_DOWN_Long_Push" /> : <Trans i18nKey="Colour_WARMER_COLDER_Long_Push" />}
                        handleChange={this.handleChange} />
                    <PropertyCheckbox
                        property={tdEd2}
                        title={tdMo.value === '2' ? <Trans i18nKey="Set_Reset_level_Double_Push" /> : <Trans i18nKey="Set_Reset_Colour_Double_Push" />}
                        handleChange={this.handleChange} />
                </Card.Body>
            </Card>)
            : null;

        const { t } = this.props;

        const powerOnComponent = (
            <Card className={this.getClassName([tdPo])}>
                <div className="card-header-feature">
                    {<Trans i18nKey="Power_ON_settings" />}
                </div>
                <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                    {this.renderEnable_P_s(
                        this.getClassName([tdPo]),
                        tdPo,
                        this.state.isEnabledTdpo,
                        t('Start_with_active_level'),
                        tdMo.value === '2' ? t('Mains_Power_ON_Level_CH1') : t('Mains_Power_ON_DALI_Level'),
                        this.getPercentage(tdPo.value, tdPo.valueMeta.min, tdPo.valueMeta.max))}
                    {
                        tdMo.value === '1' ? null :
                            this.renderEnable_P_s(
                                this.getClassName([tdMo.value === '2' ? tdPo2 : tdPoC]),
                                tdMo.value === '2' ? tdPo2 : tdPoC,
                                tdMo.value === '2' ? this.state.isEnabledTdpo2 : this.state.isEnabledTdpoC,
                                tdMo.value === '2' ? t('Start_with_active_level') : t('Start_with_active_color'),
                                tdMo.value === '2' ? t('Mains_Power_ON_Level_CH2') : t('Mains_Power_ON_Colour'),
                                tdMo.value === '3' ? t('Kelvin') : this.getPercentage(tdPo2.value, tdPo2.valueMeta.min, tdPo2.valueMeta.max))
                    }
                </Card.Body>
            </Card>
        );

        const operativeSettingsComponent = (
            <Card className={this.getClassName([tdFu, tdSo, tdOn, tdFt3])}>
                <div className="card-header-feature">
                    {<Trans i18nKey="Operative_settings" />}
                </div>
                <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', display: "flex" }}>
                    <Col className="card-body-feature-col" style={{ paddingLeft: "0" }}>
                        <PropertyDropdown
                            property={tdFu}
                            properties={tdFu.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                            propertyDisplayFunc={getHours}
                            title={<Trans i18nKey="Fade_Time_1" />}
                            measureUnit={'mm:ss'}
                            handleChange={this.handleChange} />
                        {this.renderEnable_P_s(
                            this.getClassName([tdSo]),
                            tdSo,
                            this.state.isEnabledTdso,
                            t('Use_active_level_before_Switch_OFF'),
                            t('DALI_Level') + (tdMo.value === '2' ? " CH1" : ""),
                            this.getPercentage(tdSo.value, tdSo.valueMeta.min, tdSo.valueMeta.max))}
                        {tdMo.value === '1' ? null :
                            this.renderEnable_P_s(
                                this.getClassName([tdMo.value === '2' ? tdSo2 : tdSoC]),
                                tdMo.value === '2' ? tdSo2 : tdSoC,
                                tdMo.value === '2' ? this.state.isEnabledTdso2 : this.state.isEnabledTdsoC,
                                tdMo.value === '2' ? t('Use_active_level_before_Switch_OFF') : t('Use_active_CCT_before_Switch_OFF'),
                                tdMo.value === '2' ? t('DALI_Level') + ' CH2' : t('Colour'),
                                tdMo.value === '3' ? t('Kelvin') : this.getPercentage(tdSo2.value, tdSo2.valueMeta.min, tdSo2.valueMeta.max))}
                    </Col>
                    <Col className="card-body-feature-col" style={{ paddingLeft: "0" }}>
                        <PropertyDropdown
                            property={tdOn}
                            properties={tdOn.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                            propertyDisplayFunc={this.state.frequencySelected === 50 ? getHoursTD : getHoursTD60Hz}
                            title={<Trans i18nKey="Hold_Time_2" />}
                            measureUnit={'hh:mm:ss'}
                            min={tdOn.valueMeta.min}
                            max={tdOn.valueMeta.max}
                            handleChange={this.handleChange} />
                        <PropertyDropdown
                            property={tdFt3}
                            properties={tdFt3.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                            propertyDisplayFunc={getHours}
                            title={<Trans i18nKey="Fade_Time_3" />}
                            measureUnit={'mm:ss'}
                            min={tdFt3.valueMeta.min}
                            max={tdFt3.valueMeta.max}
                            handleChange={this.handleChange} />
                    </Col>
                </Card.Body>
            </Card>
        );

        const firstRow = [];
        const secondRow = [];
        if (lightLevelControl1Component) {
            firstRow.push(lightLevelControl1Component);
        }
        if (lightLevelControl2Component) {
            firstRow.push(lightLevelControl2Component);
        }

        if (firstRow.length < 2) {
            firstRow.push(powerOnComponent);
        } else {
            secondRow.push(powerOnComponent);
        }

        if (firstRow.length < 2) {
            firstRow.push(operativeSettingsComponent);
        } else {
            secondRow.push(operativeSettingsComponent);
        }

        const dataChart = this.state.selectedGraph === "td" ? this.getDataChart(this.props.properties) : [];
        const dataChartTDS = this.state.selectedGraph === "td_s" ? this.getDataChartTDS(this.props.properties) : [];

        const chartTDComponent = this.state.selectedGraph === "td" ?
            (<DraggableAreaChart
                id={"td"}
                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                properties={this.props.properties}
                dataChart={dataChart}
                x={{ 'title': t('Time') }}
                y={{ 'title': t('Output_Level_Percent') }}
                max={{ y: 105, x: 4000 }}
                min={{ y: 0, x: 0 }}
                tickValues={{ x: [], y: [] }}
                yThresholds={[
                    { value: this.extractPercentageValue({ value: this.props.extraProperties[DALI_DEXAL_SETTINGS.maximum].value, valueMeta: { min: 1, max: 254 } }), color: 'rgb(255,0,0)' },
                    { value: this.extractPercentageValue({ value: this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum].value, valueMeta: { min: 1, max: 254 } }), color: 'rgb(255,0,0)' },
                ]}
                yLabels={this.getYLabels(dataChart)}
                xLabels={this.getXLabels(dataChart)}
                sections={{ 0: "area-light", 1: "area-light", 2: "area-dark", 3: "area-light", 4: "area-dark" }}
                handleChange={this.handleChartChange} />) : null;

        const chartTDSComponent = this.state.selectedGraph === "td_s" ?
            (<DraggableAreaChart
                id={"td_s"}
                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                properties={this.props.properties}
                dataChart={dataChartTDS}
                x={{ 'title': t('Time') }}
                y={{ 'title': t('Output_Level_Percent') }}
                max={{ y: 105, x: 4000 }}
                min={{ y: 0, x: 0 }}
                tickValues={{ x: [], y: [] }}
                yThresholds={[
                    { value: this.extractPercentageValue({ value: this.props.extraProperties[DALI_DEXAL_SETTINGS.maximum].value, valueMeta: { min: 1, max: 254 } }), color: 'rgb(255,0,0)' },
                    { value: this.extractPercentageValue({ value: this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum].value, valueMeta: { min: 1, max: 254 } }), color: 'rgb(255,0,0)' },
                ]}
                yLabels={this.getYLabels(dataChartTDS)}
                xLabels={this.getXLabels(dataChartTDS)}
                sections={{ 0: "area-light", 1: "area-light", 2: "area-dark", 3: "area-light", 4: "area-dark", 5: "area-light", 6: "area-dark" }}
                handleChange={this.handleChartChange} />) : null;

        const disabledStandBy = tdOn.value === "Infinite" ? "card-disabled" : "";

        return (
            <div className="flex-col">
                <div className="flex-row">
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Mains_Frequency" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <Dropdown>
                                <Dropdown.Toggle variant="secondary" disabled={this.props.disabled} className="edit-icon-project-header dropdown-osram">{this.state.frequencySelected}</Dropdown.Toggle>
                                <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                                    <Dropdown.Item onClick={this.handleChangeFrequency} name={50} key={50} >{50}</Dropdown.Item>
                                    <Dropdown.Item onClick={this.handleChangeFrequency} name={60} key={60} >{60}</Dropdown.Item>
                                </Dropdown.Menu>
                                Hz
                            </Dropdown>
                        </Card.Body>
                    </Card>

                    {firstRow.length >= 1 ? firstRow[0] : null}
                    {firstRow.length >= 2 ? firstRow[1] : null}

                </div>
                {
                    secondRow.length === 0 ? null :
                        (
                            <div className="flex-row">
                                {secondRow.length >= 1 ? secondRow[0] : null}
                                {secondRow.length >= 2 ? secondRow[1] : null}
                            </div>)
                }
                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([tdFd, daMin, tdSt]) + disabledStandBy}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="StandBy" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyDropdown
                                property={tdFd}
                                properties={tdFd.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={getHours}
                                title={<Trans i18nKey="Fade_Time_4" />}
                                measureUnit={'mm:ss'}
                                handleChange={this.handleChange} />
                            <PropertyPicker
                                property={daMin}
                                title={<Trans i18nKey="DALI_Level" />}
                                measureUnit={this.getPercentage(daMin.value, 1, 254)}
                                min={daMin.valueMeta.min}
                                max={daMin.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyDropdown
                                property={tdSt}
                                properties={tdSt.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={this.state.frequencySelected === 50 ? getHoursTD : getHoursTD60Hz}
                                title={<Trans i18nKey="Hold_Time_5" />}
                                measureUnit={'hh:mm:ss'}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                    <Card className={this.getClassName([tdEls, tdEpd, tdEhm, tdEap])}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Sensors" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyCheckbox
                                property={tdEls}
                                title={<Trans i18nKey="Light_sensor" />}
                                handleChange={this.handleChange} />
                            <PropertyCheckbox
                                property={tdEpd}
                                title={<Trans i18nKey="Presence_detection" />}
                                handleChange={this.handleChange} />
                            <div className={classNamePD}>
                                <PropertyCheckbox
                                    property={tdEhm}
                                    title={<Trans i18nKey="Holiday_Mode" />}
                                    handleChange={this.handleChange} />
                                <PropertyCheckbox
                                    property={tdEap}
                                    title={<Trans i18nKey="Auto_disable_Presence_Detection" />}
                                    handleChange={this.handleChange} />
                            </div>
                        </Card.Body>
                    </Card>
                </div>
                <div className="flex-column">
                    <Tabs style={{ margin: "0", paddingTop: "0.75rem" }} onSelect={(k) => this.setState({ selectedGraph: k })}>
                        <Tab eventKey="td" title="TouchDIM">
                            <Card className="card-feature-component" style={{ width: '100%', marginTop: "2px" }}>
                                <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                                    {chartTDComponent}
                                </Card.Body>
                            </Card>
                        </Tab>
                        <Tab eventKey="td_s" title="TouchDIM + Sensor">
                            <Card className="card-feature-component" style={{ width: '100%', marginTop: "2px" }}>
                                <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                                    {chartTDSComponent}
                                </Card.Body>
                            </Card>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        );
    }

    getXLabels(dataChart) {

        const labels = [];
        const smallLabels = [];
        const ticks = [];

        dataChart.forEach((el, index) => {
            switch (el.timeLabel) {
                case 'startTime-0':
                    ticks.push(el.x);
                    labels.push({ label: 'On', x: el.x });
                    break;
                case 'fadeUpTime-1':
                    ticks.push(el.x);
                    smallLabels.push({ label: '1', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'holdTime-2':
                    ticks.push(el.x);
                    labels.push({ label: 'Off', x: el.x });
                    break;
                case 'fadeDownTime-3':
                    ticks.push(el.x);
                    smallLabels.push({ label: '3', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'fadeDownTime-2':
                    ticks.push(el.x);
                    smallLabels.push({ label: '2', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'fadeDownTime-4':
                    ticks.push(el.x);
                    smallLabels.push({ label: '4', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'holdTime-5':
                    ticks.push(el.x);
                    smallLabels.push({ label: '5', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'enter':
                    ticks.push(el.x);
                    smallLabels.push({ label: 'Enter', x: el.x });
                    break;
                case 'exit':
                    ticks.push(el.x);
                    smallLabels.push({ label: 'Exit', x: el.x });
                    break;
                default:
                    break;
            }
        });

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getYLabels(dataChart) {
        const labels = {};

        //insert zero label
        const zero = Math.round(this.extractPercentageValue({ value: 0, valueMeta: { min: 1, max: 254 } }));
        labels[zero] = { label: '0', y: zero };

        //insert data labels
        dataChart.forEach((el) => {
            const val = Math.round(el.y);
            if (!labels[val]) {
                labels[val] = { label: val.toString(), y: val }
            }
        });

        //insert max label properties if max value is not present
        const max = Math.round(this.extractPercentageValue({ value:
            this.props.extraProperties[DALI_DEXAL_SETTINGS.maximum] ? this.props.extraProperties[DALI_DEXAL_SETTINGS.maximum].value : 255,
        valueMeta: { min: 1, max: 254 } }));
        if (!labels[max]) {
            labels[max] = { label: 'max', y: max };
        }

        //insert min label properties if min value is not present
        const min = Math.round(this.extractPercentageValue({ value:
            this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum] ? this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum].value : 0,
        valueMeta: { min: 1, max: 254 } }));
        if (!labels[min]) {
            labels[min] = { label: 'min', y: min };
        }

        //replace min label value with 'min'
        labels[min].label = 'min';

        return Object.keys(labels).map((key) => { return labels[key]; });
    }

    getDataChart(properties) {

        const dataChart = [{}, {}, {}, {}, {}, {}, {}];

        dataChart[0].x = 300;
        dataChart[0].y = 0;
        dataChart[0].section = 0;

        dataChart[1].x = dataChart[0].x;
        dataChart[1].y = +this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]);
        dataChart[1].timeLabel = "startTime-0";
        dataChart[1].section = 0;

        const fadeUpTimeIndex = properties[TOUCH_DIM_AND_SENSOR.fadeUpTime].valueMeta.availableValues.indexOf(properties[TOUCH_DIM_AND_SENSOR.fadeUpTime].value);
        dataChart[2].x = dataChart[1].x + (fadeUpTimeIndex > 0 ? (100 + fadeUpTimeIndex * 25) : 0);
        dataChart[2].y = +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]);
        dataChart[2].timeLabel = "fadeUpTime-1";
        dataChart[2].section = 1;

        dataChart[3].x = dataChart[2].x + 300;
        dataChart[3].y = +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]);
        dataChart[3].timeLabel = "holdTime-2";
        dataChart[3].section = 2;

        const fadeDownTime03Index = properties[TOUCH_DIM_AND_SENSOR.fadeDownTime03].valueMeta.availableValues.indexOf(properties[TOUCH_DIM_AND_SENSOR.fadeDownTime03].value);
        dataChart[4].x = dataChart[3].x + (fadeDownTime03Index > 0 ? (100 + fadeDownTime03Index * 5) : 0);
        dataChart[4].y = +this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]);
        dataChart[4].timeLabel = "fadeDownTime-3";
        dataChart[4].section = 3;

        dataChart[5].x = dataChart[4].x;
        dataChart[5].y = +this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]);
        dataChart[5].timeLabel = "holdTime-4";
        dataChart[5].section = 4;

        dataChart[6].x = dataChart[4].x;
        dataChart[6].y = 0;
        dataChart[6].section = 4;

        // Setting data for the chart
        // dataChart = dataChart.filter((d) => d.x && d.y && d.x !== "Off" && d.y !== "Off" );

        return dataChart;
    }

    getDataChartTDS(properties) {

        const dataChart = [];

        if (properties[TOUCH_DIM_AND_SENSOR.presenceHoldTime].value === "Infinite") {
            dataChart.push({ x: 0, y: 0, section: 0 });

            dataChart.push({
                x: 0,
                y: +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
                section: 0
            });

            dataChart.push({
                x: 300,
                y: +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
                timeLabel: "enter",
                section: 0
            });

            const fadeUpTimeIndex = properties[TOUCH_DIM_AND_SENSOR.fadeUpTime].valueMeta.availableValues.indexOf(properties[TOUCH_DIM_AND_SENSOR.fadeUpTime].value);
            dataChart.push({
                x: dataChart[dataChart.length - 1].x + (fadeUpTimeIndex > 0 ? (100 + fadeUpTimeIndex * 25) : 0),
                y: +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
                timeLabel: "fadeUpTime-1",
                section: 1
            });

            dataChart.push({
                x: dataChart[dataChart.length - 1].x + 300,
                y: +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
                timeLabel: "exit",
                section: 2
            });

            dataChart.push({
                x: 4000,
                y: +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
                timeLabel: "fadeDownTime-2",
                section: 5
            });

            dataChart.push({
                x: 4000,
                y: 0,
                section: 5
            });

        } else {
            if (properties[TOUCH_DIM_AND_SENSOR.standbyHoldTime].value === "Infinite") {
                dataChart.push({ x: 0, y: 0, section: 0 });

                dataChart.push({
                    x: 0,
                    y: this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]),
                    section: 0
                });
            } else {
                dataChart.push({
                    x: 300,
                    y: 0,
                    section: 0
                });
            }

            dataChart.push({
                x: 300,
                y: this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]),
                timeLabel: "enter",
                section: 0
            });

            const fadeUpTimeIndex = properties[TOUCH_DIM_AND_SENSOR.fadeUpTime].valueMeta.availableValues.indexOf(properties[TOUCH_DIM_AND_SENSOR.fadeUpTime].value);
            dataChart.push({
                x: dataChart[dataChart.length - 1].x + (fadeUpTimeIndex > 0 ? (100 + fadeUpTimeIndex * 25) : 0),
                y: +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
                timeLabel: "fadeUpTime-1",
                section: 1
            });

            dataChart.push({
                x: dataChart[dataChart.length - 1].x + 300,
                y: +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
                timeLabel: "exit",
                section: 2
            });

            const holdTime02Index = properties[TOUCH_DIM_AND_SENSOR.presenceHoldTime].valueMeta.availableValues.indexOf(properties[TOUCH_DIM_AND_SENSOR.presenceHoldTime].value);
            dataChart.push({
                x: dataChart[dataChart.length - 1].x + (holdTime02Index > 0 ? (100 + holdTime02Index) : 0),
                y: +this.validateValue(properties[TOUCH_DIM_AND_SENSOR.switchOnLevel]),
                timeLabel: "fadeDownTime-2",
                section: 3
            });

            const fadeDownTime04Index = properties[CORRIDOR.fadeDownTime].valueMeta.availableValues.indexOf(properties[CORRIDOR.fadeDownTime].value);
            dataChart.push({
                x: dataChart[dataChart.length - 1].x + (fadeDownTime04Index > 0 ? (100 + fadeDownTime04Index * 25) : 0),
                y: this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]),
                timeLabel: "fadeDownTime-4",
                section: 4
            });

            if (properties[TOUCH_DIM_AND_SENSOR.standbyHoldTime].value === "Infinite") {
                dataChart.push({
                    x: 4000,
                    y: this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]),
                    timeLabel: "holdTime-5",
                    section: 5
                });

                dataChart.push({
                    x: 4000,
                    y: this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]),
                    section: 5
                });
            } else {
                const holdTime05Index = properties[TOUCH_DIM_AND_SENSOR.standbyHoldTime].valueMeta.availableValues.indexOf(properties[TOUCH_DIM_AND_SENSOR.standbyHoldTime].value);
                dataChart.push({
                    x: dataChart[dataChart.length - 1].x + (holdTime05Index > 0 ? (100 + holdTime05Index * 2) : 0),
                    y: this.extractPercentageValue(this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum]),
                    timeLabel: "holdTime-5",
                    section: 5
                });

                dataChart.push({
                    x: dataChart[dataChart.length - 1].x,
                    y: 0,
                    section: 5
                });
            }
        }

        // Setting data for the chart
        // dataChart = dataChart.filter((d) => d.x && d.y && d.x !== "Off" && d.y !== "Off" );

        return dataChart;
    }

    extractPercentageValue(property) {
        if (property.value === 0 || property.value === '0') {
            // Otherwise getPercentage return ""
            return 0;
        }
        return parseFloat(this.getPercentage(property.value, property.valueMeta.min, property.valueMeta.max).replace('≈ ', '').replace(' %', ''));
    }

    validateValue(property) {
        //return property.value === 'Off' ? property.valueMeta.off : property.value;
        return property.value === 'Off' ? "100" : this.extractPercentageValue(property);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTranslation()
)(TouchDim);
